import { Button, type ButtonProps as MuiButtonProps } from "@mui/material";
import type { LinkProps } from "@tanstack/react-router";

type ButtonProps = MuiButtonProps & {
  to?: LinkProps["to"];
};

export const BaseButton = ({ sx, ...props }: ButtonProps) => {
  return (
    <Button
      sx={{
        borderRadius: "24px",
        fontWeight: 700,
        minWidth: {
          xs: "auto",
          sm: "192px",
        },
        ...sx,
      }}
      {...props}
    />
  );
};
